export { default } from "./LowResultsSection";
